//邮箱
const VALID_EMAIL_PATTERN = new RegExp(/^[-a-zA-Z0-9_.]{1,}@[a-zA-Z0-9]{2,}[.]{1}[a-zA-Z]{2,}$/)
//手机号 最低6位数字
const VALID_MOBILE_PATTERN = new RegExp(/^[0-9]{6,}$/)
//密码6-18位
const VALID_PASSWORD_PATTERN = new RegExp(/^[a-zA-Z0-9]{6,18}$/)
//地区编号
const VALID_COUNTRY_NUM_PATTERN = new RegExp(/^[0-9]{1,4}$/)
//验证码
const VALID_SMS_CODE = new RegExp(/^[0-9]{6}$/)

const VALID_USERNAME_PATTERN = new RegExp(/^[_a-zA-Z0-9]{6,18}$/)

const VALID_NICKNAME_PATTERN = new RegExp(/^[^]{1,20}$/)
// 2个大写字母
const VALID_COUNTRY_CODE_PATTERN = new RegExp(/^[A-Z]{2}$/)
// 3个大写字母
const VALID_COUNTRY_CODE_ISO_PATTERN = new RegExp(/^[A-Z]{3}$/)
//  匹配双引号里面的值
const VALID_TOPIC_NAME_TEST = new RegExp(/"([^"]*)"/)

//身份证号
const VALID_IDCARD = new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/)

export const requireNonNull = function (field) {
  if (field !== null && typeof field !== 'undefined' && field.toString().trim() !== '') {
    return field
  } else {
    return null
  }
}

export const isNotEmptyStr = (str) => {
  return str !== null && typeof str !== 'undefined' && str.toString().trim() !== ''
}

export const isEmailValid = (email) => {
  if (!isNotEmptyStr(email)) {
    return false
  }
  return VALID_EMAIL_PATTERN.test(email)
}

export const isEmailValidPattern = (email) => {
  return VALID_EMAIL_PATTERN
}

export const mobileValid = () => {
  return VALID_MOBILE_PATTERN
}
// 手机号校验
export const isMobileValid = (mobile) => {
  if (!isNotEmptyStr(mobile)) {
    return false
  }
  return VALID_MOBILE_PATTERN.test(mobile)
}

export const isPasswordValid = (password) => {
  if (!isNotEmptyStr(password)) {
    return false;
  }
  return VALID_PASSWORD_PATTERN.test(password);
}

export const isCountryNumValid = (countryNum) => {
  if (!isNotEmptyStr(countryNum)) {
    return false;
  }
  return VALID_COUNTRY_NUM_PATTERN.test(countryNum);
}
export const isSmscode = (code) => {
  if (!isNotEmptyStr(code)) {
    return false;
  }
  return VALID_SMS_CODE.test(code);
}
export const smscode = () => {
  return VALID_SMS_CODE
}

export const isUsernameValid = (username) => {
  if (!isNotEmptyStr(username)) {
    return false;
  }
  return VALID_USERNAME_PATTERN.test(username);
}

export const isNicknameValid = (nickname) => {
  if (!isNotEmptyStr(nickname)) {
    return false;
  }
  return VALID_NICKNAME_PATTERN.test(nickname);
}

export const isCountryCodeValid = (code) => {
  if (!isNotEmptyStr(code)) {
    return false;
  }
  return VALID_COUNTRY_CODE_PATTERN.test(code);
}

export const isCountryCodeIsoValid = (codeIso) => {
  if (!isNotEmptyStr(codeIso)) {
    return false;
  }
  return VALID_COUNTRY_CODE_ISO_PATTERN.test(codeIso);
}
export const IstopicNameValid = (codeIso) => {
  if (!isNotEmptyStr(codeIso)) {
    return false;
  }
  return VALID_TOPIC_NAME_TEST.test(codeIso);
}

export const isIdCard = (idcard) => {
  if (!isNotEmptyStr(idcard)) {
    return false;
  }
  return VALID_IDCARD.test(idcard);
}
export const idCardValid = () => {
  return VALID_IDCARD
}



// WEBPACK FOOTER //
// ./src/utils/coding-utils.js